import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface ReadMetaRequestDTO extends PerformedByRequestDTO {
    userId?: number;
    userEmail?: string;
    roleCd?: string;
    contextCd?: string;
    profileCd?: string;
    categories?: string;
    languageCd?: string;
    isInternal?: boolean;
    filterText?: string;
}

export interface ReadAccessPermissionsRequestDTO extends PerformedByRequestDTO {}
